import { useT } from "../i18n/hooks.ts";

/** List of errors, blockers and notices, in a popover under the bell icon — hidden unless requested. */
export function NoticesPopover({
  errors,
  blocking,
  notices,
}: {
  /** Real engine failures (see `calculationError` in App.tsx) — not business rules, something actually broke. Shown first. */
  errors: string[];
  /** Block simulation (see src/model/validations.ts) — shown next, highlighted. */
  blocking: string[];
  /** Don't block simulation, just inform. */
  notices: string[];
}) {
  const t = useT();
  return (
    <div className="popover notices-popover">
      <h3>{t("topbar.notices")}</h3>
      {errors.length === 0 && blocking.length === 0 && notices.length === 0 ? (
        <p className="no-notices">{t("noticesPopover.noWarnings")}</p>
      ) : (
        <ul className="notices-list">
          {errors.map((e) => (
            <li key={e} className="error-notice">
              <span aria-hidden="true">🔴</span>
              <span>{e}</span>
            </li>
          ))}
          {blocking.map((a) => (
            <li key={a} className="blocking-notice">
              <span aria-hidden="true">⛔</span>
              <span>{a}</span>
            </li>
          ))}
          {notices.map((a) => (
            <li key={a}>
              <span aria-hidden="true">⚠️</span>
              <span>{a}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
